// JavaScript client library for accessing the Menus API
/* eslint-disable */

import moment from 'moment';

const baseUrl = determineBaseUrl();
const tier = determineTier();

export default {

  baseUrl: baseUrl,

  tier: tier,

  dateToString: function(date) {
    return moment(date).format("YYYY-MM-DD");
  },

  // Gets a GUID from the XHR response Location header.
  // Useful for getting the GUID of a created object.
  getIdFromLocationHeader: function(xhr) {
    const locationHeader = xhr.getResponseHeader('Location');
    const regex = /[0-9A-Fa-f]{8}[-]?(?:[0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}/;
    return regex.exec(locationHeader)[0];
  }
}

// determines base URL for current environment
function determineBaseUrl() {
  switch (window.location.hostname) {

    case 'qa.dining.purdue.edu':
    case 'new.qa.dining.purdue.edu':
      return 'https://qa.api.hfs.purdue.edu/menus/';

    case 'dev.dining.purdue.edu':
    case 'localhost': // for local development; comment this line out to target production whilst running locally :)
      return 'https://dev.api.hfs.purdue.edu/menus/';

    default:
      return 'https://api.hfs.purdue.edu/menus/';
  }
}

function determineTier() {
  switch (window.location.hostname) {

    case 'dev.dining.purdue.edu':
      return 'DEV';

    case 'qa.dining.purdue.edu':
      return 'QA';

    case 'dining.purdue.edu':
      return 'PROD';

    default:
      return 'LOCAL';
  }
}
